import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  Box,
  Container,
  TextField,
  Chip,
} from "@mui/material";
import {
  add_property,
  delete_old_image_market,
  get_agents,
  get_amenities,
  get_city,
  get_common_facilities,
  get_nearby_place,
  get_owners,
  get_state,
  update_edit_property,
  update_property,
} from "../../../api/ControllApi";
import { get_property_type } from "../../../api/ControllApi";
import { useNavigate } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import { Skeleton } from "@mui/material";
import {
  Checkbox,
} from "@mui/material";
import {
  GoogleMap,
  MarkerF,
  useJsApiLoader,
  Autocomplete as GMapAutocomplete,
} from "@react-google-maps/api";
import { useSettings } from "../../../context/Settings";

const MAPS_LIBRARIES = ["places"];

export default function AddPropertyForm() {
  const [loading, setLoading] = useState(false);
  const navi = useNavigate();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [oldImages, setOldImages] = useState([]);
  const [oldPlot, setOldPlot] = useState(null);
  const [oldBlue, setOldBlue] = useState(null);
  const [old3D, setOld3D] = useState(null);
  const [preview3D, setPreview3D] = useState(null);
  const [oldDocument, setOldDocument] = useState(null);
  const [documentPreview, setDocumentPreview] = useState(null);

  const { settings } = useSettings();

  const [propertyType, setPropertyType] = useState([]);
  const [nearbyPlaces, setNearbyPlaces] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [commonFacilities, setCommonFacilities] = useState([]);
  const [owners, setOwners] = useState([]);
  const [agents, setAgents] = useState([]);
  const [newGalleryPreviews, setNewGalleryPreviews] = useState([]);
  const [plotPreview, setPlotPreview] = useState(null);

  const closeBtnStyle = {
    position: "absolute",
    top: -5,
    right: -5,
    background: "#fff",
    border: "1px solid #000",
    borderRadius: "50%",
    width: 16,
    height: 16,
    fontSize: 10,
    cursor: "pointer",
    padding: 0,
    lineHeight: 1,
  };

  const [form, setForm] = useState({
    name: "",
    type: "",
    state: "",
    city: "",
    address: "",
    area: "",
    price: "",
    unit_spilt: "",
    plot_count: "",
    lat: "",
    long: "",
    description: "",
    uld_no: "",
    document_session: "",
    amenities: [],
    commonfacility: [],
    nearby: [{ place: "", distance: "" }],
    status: 0,
    image: [],
    plot_image: null,
    blue_print: null,
    three_d_image: null,
    document: null,
    youtube_link: "",
  });

  // ✅ isEdit declared BEFORE any useEffect that references it
  const { id } = useParams();
  const location = useLocation();
  const [editData, setEditData] = useState([]);
  const isEdit = Boolean(id);
  const [loadingEditData, setLoadingEditData] = useState(false);
  const galleryInputRef = useRef(null);
  const thumbnailInputRef = useRef(null);

  // ✅ These useEffects now come AFTER isEdit is declared
  useEffect(() => {
    if (isEdit && oldPlot && !plotPreview) {
      setPlotPreview(oldPlot);
    }
  }, [isEdit, oldPlot]);

  useEffect(() => {
    if (isEdit && old3D && !preview3D) {
      setPreview3D(old3D);
    }
  }, [isEdit, old3D]);

  useEffect(() => {
    if (!isEdit) return;
    setLoadingEditData(true);
    update_edit_property(id)
      .then((res) => setEditData(res?.data))
      .catch((err) => {})
      .finally(() => setLoadingEditData(false));
  }, [id, isEdit]);

  const removeOldImage = (index) => {
    setOldImages((prev) => prev.filter((_, i) => i !== index));
  };

  const removeNewImage = (index) => {
    setForm((prev) => ({
      ...prev,
      image: prev.image.filter((_, i) => i !== index),
    }));
  };

  const handleAmenitiesChange = (event) => {
    const {
      target: { value },
    } = event;
    setForm((prev) => ({
      ...prev,
      amenities: typeof value === "string" ? value.split(",") : value,
    }));
  };

  const handleNearbyChange = (index, field, value) => {
    const updated = [...form.nearby];
    updated[index][field] = value;
    setForm((prev) => ({ ...prev, nearby: updated }));
  };

  const addNearby = () => {
    setForm((prev) => ({
      ...prev,
      nearby: [...prev.nearby, { place: "", distance: "" }],
    }));
  };

  const removeNearby = (index) => {
    if (index === 0) return;
    setForm((prev) => ({
      ...prev,
      nearby: prev.nearby.filter((_, i) => i !== index),
    }));
  };

  const removeOldPlot = () => setOldPlot(null);
  const removeOldBlue = () => setOldBlue(null);
  const removeNewPlot = () => setForm((prev) => ({ ...prev, plot_image: null }));
  const removeNewBlue = () => setForm((prev) => ({ ...prev, blue_print: null }));

  useEffect(() => {
    if (isEdit && editData) {
      setForm({
        name: editData.name || "",
        type: editData.type || "",
        state: editData.state ? String(editData.state) : "",
        address: editData.address || "",
        area: editData.area || "",
        price: editData.price || "",
        unit_spilt: editData.unit_spilt || "",
        plot_count: editData.plot_count || "",
        lat: editData.lat || "",
        long: editData.long || "",
        description: editData.description || "",
        uld_no: editData.uld_no || "",
        document_session: editData.document_session || "",
        amenities: editData.aminities
          ? typeof editData.aminities === "string"
            ? editData.aminities.split(",").map((s) => s.trim()).filter(Boolean)
            : Array.isArray(editData.aminities)
            ? editData.aminities.map(String)
            : []
          : [],
        commonfacility: editData.commonfacility
          ? typeof editData.commonfacility === "string"
            ? editData.commonfacility.split(",").map((s) => s.trim()).filter(Boolean)
            : Array.isArray(editData.commonfacility)
            ? editData.commonfacility.map(String)
            : []
          : [],
        nearby: editData.nearby_places?.length
          ? editData.nearby_places.map((n) => ({
              place: String(n.place),
              distance: String(n.distance),
            }))
          : [{ place: "", distance: "" }],
        status: editData.status !== undefined ? Number(editData.status) : 0,
        image: [],
        plot_image: null,
        blue_print: null,
        three_d_image: null,
        document: null,
        youtube_link: editData.youtube_link || "",
      });

      const normalizeUrl = (path) => {
        if (!path) return null;
        const full = path.startsWith("http") ? path : process.env.REACT_APP_ASSET_BASE_URL + path;
        // decodeURI first to avoid double-encoding, then encodeURI to handle spaces/special chars
        return encodeURI(decodeURI(full));
      };

      setOldImages((editData.image || []).map(normalizeUrl).filter(Boolean));
      setOldPlot(normalizeUrl(editData.plot_image));
      setOldBlue(normalizeUrl(editData.blue_print));
      setOld3D(normalizeUrl(editData.three_d_image));
      setOldDocument(editData.document || null);
    }
  }, [isEdit, editData]);

  useEffect(() => {
    if (isEdit && editData && cities.length > 0) {
      setForm((prev) => ({
        ...prev,
        city: editData.city?.id
          ? String(editData.city.id)
          : editData.city
          ? String(editData.city)
          : "",
      }));
    }
  }, [cities]);

  useEffect(() => {
    if (isEdit && editData && owners.length > 0) {
      setForm((prev) => ({
        ...prev,
        owner: editData.owner?.id ? String(editData.owner.id) : "",
      }));
    }
  }, [owners, isEdit, editData]);

  useEffect(() => {
    if (isEdit && editData && agents.length > 0) {
      setForm((prev) => ({
        ...prev,
        agent: editData.agent?.id ? String(editData.agent.id) : "",
      }));
    }
  }, [agents, isEdit, editData]);

  const getState = () => {
    get_state()
      .then((res) => setStates(res?.data))
      .catch((err) => {});
  };

  const getCity = async (value) => {
    try {
      const res = await get_city({ state_id: value });
      setCities(res?.data || []);
    } catch (err) {

    }
  };

  const getProperty = () => {
    get_property_type()
      .then((res) => setPropertyType(res?.data))
      .catch((err) => {});
  };

  const getNearbyList = () => {
    get_nearby_place()
      .then((res) => setNearbyPlaces(res.data.nearby_places))
      .catch((err) => {});
  };

  const getNAmenitiesList = () => {
    get_amenities()
      .then((res) => setAmenities(res.data.amenities))
      .catch((err) => {});
  };

  const getOwnerList = () => {
    get_owners()
      .then((res) => {
        const ownerOptions = res.data.owners.map((owner) => ({
          id: owner.id,
          name: owner.name,
        }));
        setOwners(ownerOptions);
      })
      .catch((err) => {});
  };

  const getAgentList = () => {
    get_agents()
      .then((res) => {
        const agentOptions = res.data.agents.map((agent) => ({
          id: agent.id,
          name: agent.name,
        }));
        setAgents(agentOptions);
      })
      .catch((err) => {});
  };

  const getCommonFacilityList = () => {
    get_common_facilities()
      .then((res) => setCommonFacilities(res.data || []))
      .catch((err) => {});
  };

  useEffect(() => {
    getState();
    getProperty();
    getNearbyList();
    getNAmenitiesList();
    getOwnerList();
    getAgentList();
    getCommonFacilityList();
  }, []);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyBMORJwqAENHll476u4UXGJmV_bSFJycA8",
    libraries: MAPS_LIBRARIES,
  });

  const handleMapClick = (e) => {
    const lat = e.latLng.lat();
    const long = e.latLng.lng();

    setForm((prev) => ({
      ...prev,
      lat: lat.toFixed(6),
      long: long.toFixed(6),
    }));

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng: long } }, (results, status) => {
      if (status === "OK" && results[0]) {
        setForm((prev) => ({ ...prev, address: results[0].formatted_address }));
      }
    });
  };

  const containerStyle = { width: "100%", height: "300px" };
  const defaultCenter = { lat: 10.99835602, lng: 77.01502627 };

  const selectedNearbyIds = form.nearby.map((n) => n.place).filter(Boolean);

  const autocompleteRef = useRef(null);
  const mapRef = useRef(null);

  const onLoadMap = (map) => { mapRef.current = map; };
  const onLoadAutocomplete = (autocomplete) => { autocompleteRef.current = autocomplete; };

  const onPlaceChanged = () => {
    if (!autocompleteRef.current) return;
    const place = autocompleteRef.current.getPlace();
    if (!place || !place.geometry || !place.geometry.location) return;

    const lat = place.geometry.location.lat();
    const long = place.geometry.location.lng();
    if (!isFinite(lat) || !isFinite(long)) return;

    setForm((prev) => ({
      ...prev,
      address: place.formatted_address || "",
      lat,
      long,
    }));

    if (mapRef.current) {
      mapRef.current.panTo({ lat, lng: long });
      mapRef.current.setZoom(15);
    }
  };

  useEffect(() => {
    if (form.state) {
      getCity(form.state);
    }
  }, [form.state]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "name") {
      const regex = /^[A-Za-z0-9\s]*$/;
      if (!regex.test(value)) return;
    }

    if (name === "image") {
      const fileArray = Array.from(files);
      const allowedTypes = [
        "image/jpeg","image/jpg","image/png","image/jfif",
        "video/mp4","video/quicktime","video/x-msvideo","video/x-matroska",
      ];
      const validFiles = fileArray.filter((file) => allowedTypes.includes(file.type));
      if (validFiles.length < fileArray.length) {
        toast.error("Invalid file type. Only standard images and mp4/mov/avi/mkv videos are allowed.");
      }
      if (validFiles.length > 0) {
        setForm((prev) => ({ ...prev, image: [...(prev.image || []), ...validFiles] }));
        setNewGalleryPreviews((prev) => [
          ...prev,
          ...validFiles.map((file) => ({
            src: URL.createObjectURL(file),
            type: file.type.startsWith("video") ? "video" : "image",
          })),
        ]);
      }
      return;
    }

    if (name === "plot_image") {
      const file = files[0];
      if (file && !["image/jpeg","image/jpg","image/png","image/jfif"].includes(file.type)) {
        toast.error("Only jpg, jpeg, png, and jfif images are allowed.");
        e.target.value = null;
        return;
      }
      if (file) {
        setForm((prev) => ({ ...prev, plot_image: file }));
        setPlotPreview(URL.createObjectURL(file));
      }
      return;
    }

    if (name === "three_d_image") {
      const file = files[0];
      if (file && !["image/jpeg","image/jpg","image/png","image/jfif"].includes(file.type)) {
        toast.error("Only jpg, jpeg, png, and jfif images are allowed.");
        e.target.value = null;
        return;
      }
      if (file) {
        setForm((prev) => ({ ...prev, three_d_image: file }));
        setPreview3D(URL.createObjectURL(file));
      }
      return;
    }

    if (name === "document") {
      const file = files[0];
      if (file) {
        setForm((prev) => ({ ...prev, document: file }));
        setDocumentPreview(file.name);
      }
      return;
    }

    if (name === "state") {
      setForm((prev) => ({ ...prev, state: value, city: "" }));
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleDeleteOldImage = async (imagePath, index, id) => {
    const filename = imagePath.split("/").pop();
    try {
      await delete_old_image_market(id, filename);
      setOldImages((prev) => prev.filter((_, i) => i !== index));
      toast.success("Image deleted successfully");
    } catch (err) {

      toast.error("Failed to delete image");
    }
  };

  const removeGalleryImage = (index) => {
    setForm((prev) => ({
      ...prev,
      image: prev.image.filter((_, i) => i !== index),
    }));
    setNewGalleryPreviews((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!form.name || form.name.trim() === "") {
        toast.error("Property name is required");
        setLoading(false);
        return;
      }
      if (!form.address || form.address.trim() === "") {
        toast.error("Address is required");
        setLoading(false);
        return;
      }
      if (!form.description || form.description.trim() === "") {
        toast.error("Description is required");
        setLoading(false);
        return;
      }
      if (!form.lat) {
        toast.error("Select in Map");
        setLoading(false);
        return;
      }
      if (!form.long) {
        toast.error("Select in Map");
        setLoading(false);
        return;
      }
      if (!form.amenities || form.amenities.length === 0) {
        toast.error("Please select at least one amenity");
        setLoading(false);
        return;
      }
      if (!form.uld_no || form.uld_no.trim() === "") {
        toast.error("ULPIN Number is required");
        setLoading(false);
        return;
      }

      for (const key in form) {
        if (
          ["image","plot_image","three_d_image","blue_print","nearby","uld_no","document",
           "document_session","owner","agent","youtube_link"].includes(key)
        ) continue;
        if (form[key] === "" || form[key] === null || form[key] === undefined) {
          const fieldName = key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
          toast.error(`Please fill the ${fieldName} field`);
          setLoading(false);
          return;
        }
      }

      if (form.nearby.length === 0) {
        toast.error("Please add at least one nearby place");
        setLoading(false);
        return;
      }

      for (const n of form.nearby) {
        if (!n.place || !n.distance) {
          toast.error("Nearby places must have place and distance");
          setLoading(false);
          return;
        }
      }

      const hasPropertyMedia =
        (form.image && form.image.length > 0) || (oldImages && oldImages.length > 0);
      if (!hasPropertyMedia) {
        toast.error("Please upload at least one property image or video");
        setLoading(false);
        return;
      }

      const hasPlotImage = form.plot_image || oldPlot;
      if (!hasPlotImage) {
        toast.error("Please upload plot image");
        setLoading(false);
        return;
      }

      const has3DImage = form.three_d_image || old3D;
      if (!has3DImage) {
        toast.error("Please upload 3D image");
        setLoading(false);
        return;
      }

      const formData = new FormData();
      if (isEdit) formData.append("id", id);

      Object.keys(form).forEach((key) => {
        if (
          ["image","plot_image","three_d_image","blue_print","nearby","uld_no",
           "document","owner","agent","latitude","longitude","youtube_link"].includes(key)
        ) return;
        if (form[key] !== "" && form[key] !== null) {
          // form key is unit_spilt (for display), but backend expects unit_split
          if (key === "unit_spilt") {
            formData.append("unit_split", Number(form[key]));
          } else {
            formData.append(key, form[key]);
          }
        }
      });

      if (form.uld_no !== "" && form.uld_no !== null) {
        formData.append("uld_no", form.uld_no);
      }

      if (form.amenities.length > 0) {
        formData.append("amenities", JSON.stringify(form.amenities));
      }

      if (form.commonfacility.length > 0) {
        form.commonfacility.forEach((id) => formData.append("commonfacility[]", id));
      }

      const nearbyPayload = form.nearby
        .filter((n) => n.place && n.distance)
        .map((n) => ({ place: Number(n.place), distance: Number(n.distance) }));
      formData.append("nearby", JSON.stringify(nearbyPayload));

      if (form.image.length > 0) {
        form.image.forEach((file) => formData.append("image[]", file));
      }

      if (!form.lat || !form.long) {
        toast.error("Please select address in map");
        setLoading(false);
        return;
      }

      if (!form.plot_count) {
        toast.error("Please enter Plot Count");
        setLoading(false);
        return;
      }

      if (form.plot_image) formData.append("plot_image", form.plot_image);
      if (form.three_d_image) formData.append("three_d_image", form.three_d_image);
      if (form.blue_print) formData.append("blue_print", form.blue_print);
      if (form.document) formData.append("document", form.document);
      formData.append("youtube_link", form.youtube_link || "");

      let response;
      if (isEdit) {
        response = await update_property(formData);
      } else {
        response = await add_property(formData);
      }

      if (response.status === 200) {
        toast.success(
          response?.message ||
            (isEdit
              ? "Residential Property updated successfully"
              : "Residential Property added successfully")
        );
        setTimeout(() => navi("/dashboard/my_markplace_plot"), 1000);
      } else {
        toast.error("Something went wrong");
      }
    } catch (err) {

      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Box
        sx={{
          mx: "auto",
          mt: 6,
          mb: 6,
          p: 4,
          backgroundColor: "#f9f9f9",
          border: "1px solid #ddd",
          borderRadius: 3,
          boxShadow: 1,
        }}
      >
        {loadingEditData ? (
          <PropertyFormSkeleton />
        ) : (
          <Form onSubmit={handleSubmit}>
            <h3 className="mb-4 text-center">{isEdit ? "Edit" : "Add"} Land</h3>

            {/* Row 1: Name, Type */}
            <Row className="g-3">
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Property Name <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control
                    name="name"
                    type="text"
                    placeholder="Enter Property Name"
                    value={form.name}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Type <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Select name="type" value={form.type} onChange={handleChange}>
                    <option value="">Category Type</option>
                    {propertyType.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.category_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {/* Row 2: State, City */}
            <Row className="g-3">
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>State <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Select name="state" value={form.state} onChange={handleChange}>
                    <option value="">Select State</option>
                    {states.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.state_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>City <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Select name="city" value={form.city} onChange={handleChange}>
                    <option value="">Select City</option>
                    {cities.map((item) => (
                      <option key={item.id} value={String(item.id)}>
                        {item.city_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {/* Row 3: Area, Price, Unit, Plot Count */}
            <Row className="g-3">
              <Col xs={12} md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Area (sqft) <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control
                    name="area"
                    type="number"
                    placeholder="Enter Area (e.g. 1500)"
                    value={form.area}
                    min={0}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      if (e.key === "ArrowUp" || e.key === "ArrowDown") e.preventDefault();
                    }}
                    onWheel={(e) => e.target.blur()}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Price <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control
                    name="price"
                    type="number"
                    placeholder="Enter Total Price"
                    value={form.price}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Price per Sqft <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control
                    name="unit_spilt"
                    type="number"
                    placeholder="Enter Price per Sqft"
                    value={form.unit_spilt}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Plot Count <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control
                    name="plot_count"
                    type="number"
                    placeholder="Enter Plot Count"
                    value={form.plot_count}
                    onChange={handleChange}
                    min={1}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Nearby Places */}
            <Row className="g-3 mb-3">
              <Col xs={12}>
                <h5>Nearby Places <span style={{ color: "red" }}>*</span></h5>
              </Col>
              {form.nearby.map((near, index) => {
                const filteredPlaces = nearbyPlaces.filter(
                  (place) =>
                    !selectedNearbyIds.includes(String(place.id)) ||
                    String(place.id) === String(near.place)
                );
                return (
                  <React.Fragment key={index}>
                    <Col xs={12} md={5}>
                      <Form.Group className="mb-3">
                        {index === 0 && <Form.Label>Nearby Place</Form.Label>}
                        <Form.Select
                          value={near.place}
                          onChange={(e) => handleNearbyChange(index, "place", e.target.value)}
                        >
                          <option value="">Select Nearby Place</option>
                          {filteredPlaces.map((place) => (
                            <option key={place.id} value={place.id}>
                              {place.title}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={5}>
                      <Form.Group className="mb-3">
                        {index === 0 && <Form.Label>Distance (km)</Form.Label>}
                        <Form.Control
                          type="number"
                          placeholder="Enter distance"
                          className="remove-number-arrows"
                          value={near.distance}
                          onChange={(e) => handleNearbyChange(index, "distance", e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={2} className="d-flex align-items-end gap-2 mb-3">
                      {index === 0 && (
                        <Button variant="success" onClick={addNearby}>
                          Add
                        </Button>
                      )}
                      <Button variant="danger" onClick={() => removeNearby(index)}>
                        Remove
                      </Button>
                    </Col>
                  </React.Fragment>
                );
              })}
            </Row>

            {/* Address + Map */}
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Address <span style={{ color: "red" }}>*</span></Form.Label>
                  {isLoaded ? (
                    <GMapAutocomplete
                      onLoad={onLoadAutocomplete}
                      onPlaceChanged={onPlaceChanged}
                    >
                      <Form.Control
                        placeholder="Search address"
                        value={form.address}
                        onChange={(e) => setForm({ ...form, address: e.target.value })}
                      />
                    </GMapAutocomplete>
                  ) : (
                    <Form.Control placeholder="Loading map..." disabled />
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                {isLoaded ? (
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={
                      form.lat && form.long
                        ? { lat: Number(form.lat), lng: Number(form.long) }
                        : defaultCenter
                    }
                    zoom={form.lat && form.long ? 16 : 14}
                    onLoad={onLoadMap}
                    onClick={handleMapClick}
                    options={{ }}
                  >
                    {form.lat && form.long && (
                      <MarkerF
                        position={{ lat: Number(form.lat), lng: Number(form.long) }}
                        draggable={true}
                        onDragEnd={handleMapClick}
                      />
                    )}
                  </GoogleMap>
                ) : (
                  <div style={{ height: 300 }}>Loading Map...</div>
                )}
              </Col>
            </Row>

            {/* Amenities + Common Facilities */}
            <Row className="g-3">
              <Col xs={12} md={6}>
                <Form.Group style={{ marginTop: "30px" }}>
                  <Form.Label>
                    Amenities <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Autocomplete
                    multiple
                    options={amenities}
                    getOptionLabel={(option) => option.title}
                    value={amenities.filter((a) => form.amenities.includes(String(a.id)))}
                    onChange={(event, newValue) =>
                      setForm({ ...form, amenities: newValue.map((v) => String(v.id)) })
                    }
                    disableCloseOnSelect
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox checked={selected} style={{ marginRight: 8 }} />
                        {option.title}
                      </li>
                    )}
                    renderTags={(value, getTagProps) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, maxHeight: 70, overflowY: "auto" }}>
                        {value.map((option, index) => (
                          <Chip label={option.title} {...getTagProps({ index })} size="small" />
                        ))}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={form.amenities.length === 0 ? "Select Amenities" : ""}
                        size="small"
                        sx={{ backgroundColor: "white", borderRadius: 1 }}
                      />
                    )}
                    fullWidth
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group style={{ marginTop: "30px" }}>
                  <Form.Label>
                    Common Facilities <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Autocomplete
                    multiple
                    options={commonFacilities}
                    getOptionLabel={(option) => option.title}
                    value={commonFacilities.filter((cf) =>
                      form.commonfacility.includes(String(cf.id))
                    )}
                    onChange={(event, newValue) =>
                      setForm({ ...form, commonfacility: newValue.map((v) => String(v.id)) })
                    }
                    disableCloseOnSelect
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox checked={selected} style={{ marginRight: 8 }} />
                        {option.title}
                      </li>
                    )}
                    renderTags={(value, getTagProps) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, maxHeight: 70, overflowY: "auto" }}>
                        {value.map((option, index) => (
                          <Chip label={option.title} {...getTagProps({ index })} size="small" />
                        ))}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={form.commonfacility.length === 0 ? "Select Common Facilities" : ""}
                        size="small"
                        sx={{ backgroundColor: "white", borderRadius: 1 }}
                      />
                    )}
                    fullWidth
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Description */}
            <Row className="g-3">
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" style={{ marginTop: "30px" }}>
                  <Form.Label>Description <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="description"
                    placeholder="Enter property description"
                    value={form.description}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* ULPIN + Document */}
            <Row className="g-3">
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>ULPIN Number <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control
                    name="uld_no"
                    placeholder="Enter ULPIN Number"
                    value={form.uld_no}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Document</Form.Label>
                  <Form.Control type="file" onChange={handleChange} name="document" />
                  {(oldDocument || documentPreview) && (
                    <div className="mt-2">
                      <small className="text-success">
                        ✓ {documentPreview || oldDocument.split("/").pop()}
                      </small>
                      <button
                        type="button"
                        onClick={() => {
                          setOldDocument(null);
                          setDocumentPreview(null);
                          setForm((prev) => ({ ...prev, document: null }));
                        }}
                        className="btn btn-sm btn-danger ms-2"
                      >
                        Remove
                      </button>
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>

            {/* Images */}
            <Row className="g-3">
              {["image", "plot_image", "three_d_image"].map((field) => (
                <Col xs={12} md={6} key={field}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      {field === "image"
                        ? "Property Images & Videos"
                        : field === "plot_image"
                        ? "BluePrint Image"
                        : "3D Image"}
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      multiple={field === "image"}
                      onChange={handleChange}
                      accept={field === "image" ? "image/*,video/*" : "image/*"}
                      name={field}
                    />
                    <Row className="mt-2 g-2">
                      {(field === "image"
                        ? Array.isArray(oldImages) ? oldImages : []
                        : field === "plot_image"
                        ? [plotPreview || oldPlot]
                        : [preview3D || old3D]
                      )
                        .filter(Boolean)
                        .map((file, idx) => {
                          const isVideo =
                            typeof file === "string"
                              ? file.match(/\.(mp4|mov|avi|mkv)$/i)
                              : file.type?.startsWith("video");
                          return (
                            <Col xs="auto" key={`old-${idx}`} style={{ position: "relative" }}>
                              {isVideo ? (
                                <video
                                  src={file}
                                  width={60}
                                  height={60}
                                  controls
                                  style={{ borderRadius: 4, objectFit: "cover" }}
                                />
                              ) : (
                                <img
                                  src={file}
                                  width={60}
                                  height={60}
                                  style={{ borderRadius: 4, objectFit: "cover" }}
                                  alt="old"
                                />
                              )}
                              <button
                                type="button"
                                onClick={() => {
                                  if (field === "image") {
                                    handleDeleteOldImage(file, idx, id);
                                  } else if (field === "three_d_image") {
                                    setOld3D(null);
                                    setPreview3D(null);
                                    setForm((prev) => ({ ...prev, three_d_image: null }));
                                  } else {
                                    setOldPlot(null);
                                    setPlotPreview(null);
                                    setForm((prev) => ({ ...prev, plot_image: null }));
                                  }
                                }}
                                style={closeBtnStyle}
                              >
                                ×
                              </button>
                            </Col>
                          );
                        })}

                      {field === "image" &&
                        Array.isArray(newGalleryPreviews) &&
                        newGalleryPreviews.map((preview, idx) => (
                          <Col xs="auto" key={`new-${idx}`} style={{ position: "relative" }}>
                            {preview.type === "image" ? (
                              <img
                                src={preview.src}
                                width={60}
                                height={60}
                                style={{ borderRadius: 4, objectFit: "cover" }}
                                alt="new"
                              />
                            ) : (
                              <video
                                src={preview.src}
                                width={60}
                                height={60}
                                style={{ borderRadius: 4, objectFit: "cover" }}
                              />
                            )}
                            <button
                              type="button"
                              onClick={() => removeGalleryImage(idx)}
                              style={closeBtnStyle}
                            >
                              ×
                            </button>
                          </Col>
                        ))}
                    </Row>
                  </Form.Group>
                </Col>
              ))}
              {/* YouTube Link — next to 3D Image */}
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>YouTube Link</Form.Label>
                  <Form.Control
                    name="youtube_link"
                    type="url"
                    placeholder="Enter YouTube video URL"
                    value={form.youtube_link}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button
              type="submit"
              className="mt-3"
              style={{ backgroundColor: "#6A8F3E", borderColor: "#6A8F3E" }}
              disabled={loading}
            >
              {loading ? (
                <Spinner animation="border" size="sm" />
              ) : isEdit ? (
                "Edit Property"
              ) : (
                "Add Property"
              )}
            </Button>
          </Form>
        )}
      </Box>
    </Container>
  );
}

const PropertyFormSkeleton = () => (
  <Container>
    <Box
      sx={{
        mx: "auto",
        mt: 6,
        mb: 6,
        p: 4,
        backgroundColor: "#f9f9f9",
        borderRadius: 3,
      }}
    >
      <Skeleton variant="text" width={200} height={40} sx={{ mx: "auto", mb: 4 }} />
      {[1, 2, 3, 4].map((row) => (
        <Row className="g-3 mb-3" key={row}>
          <Col xs={12} md={6}>
            <Skeleton variant="text" width="40%" height={20} />
            <Skeleton variant="rectangular" height={45} />
          </Col>
          <Col xs={12} md={6}>
            <Skeleton variant="text" width="40%" height={20} />
            <Skeleton variant="rectangular" height={45} />
          </Col>
        </Row>
      ))}
      <Skeleton variant="text" width="40%" height={20} />
      <Skeleton variant="rectangular" height={80} />
      <Skeleton variant="rectangular" height={300} sx={{ mt: 4 }} />
      <Skeleton variant="rectangular" width={160} height={45} sx={{ mt: 4 }} />
    </Box>
  </Container>
);